import {useState} from "react";

export default function BosShowTagsList({ tags = [] }) {
    const shouldCollapsed = tags.length >= 4;
    const [expandedTagId, setExpandedTagId] = useState(shouldCollapsed ? tags[0]?.value : null);

    const handleTagClick = (tagId) => {
        if (!shouldCollapsed) return;

        setExpandedTagId((current) => (current === tagId ? null : tagId));
    }

    return (
        <div className="flex gap-2">
            {tags.map((tag) => {
                const isExpanded = expandedTagId === tag.value;

                const tagLabel = shouldCollapsed && !isExpanded
                    ? `${tag.label.charAt(0)}...`
                    : tag.label;

                return (
                    <button
                        key={tag.value}
                        onClick={() => handleTagClick(tag.value)}
                        title={shouldCollapsed && !isExpanded ? tag.label : undefined}
                        className={`p-[10px] rounded-lg text-[14px]
                            ${shouldCollapsed ? "cursor-pointer" : "cursor-default"}
                        `}
                        style={{
                            color: tag.textColor,
                            backgroundColor: tag.backgroundColor,
                        }}
                    >
                        {tagLabel}
                    </button>
                )
            })}
        </div>
    )
}